import axios from "axios";
import type { Country } from "../../domain/entities/Countries";
import { ApiConfig } from "../config/apiConfig";

interface CountryResponse {
  id?: string;
  name?: string;
  code?: string;
  created_at?: string | Date;
}

const getCountryList = (responseData: unknown): CountryResponse[] => {
  if (!responseData || typeof responseData !== "object") {
    return [];
  }

  const body = responseData as {
    data?: CountryResponse[] | { countries?: CountryResponse[] };
  };

  if (Array.isArray(body.data)) {
    return body.data;
  }

  if (Array.isArray(body.data?.countries)) {
    return body.data.countries;
  }

  return [];
};

export class CountriesApi {

  async getCountries(): Promise<Country[]> {
    const response = await axios.get(ApiConfig.COUNTRIES);

    return getCountryList(response.data)
      .map((country) => ({
        id: country.id ?? "",
        name: country.name ?? "",
        code: country.code ?? "",
        created_at: new Date(country.created_at ?? ""),
      }))
      .filter((country) => country.id && country.name)
      .sort((a, b) => a.name.localeCompare(b.name));
  }
}
